import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MainService } from 'src/app/services/main/main.service';
import { PersonaService } from 'src/app/services/persona/persona.service';
import { environment } from 'src/environments/environment';
import * as REGEX from '../../../shared/regex'
import { Subscription } from 'rxjs';
import { CanonicalService } from 'src/app/services/canonical.service';
import { Meta } from '@angular/platform-browser';
import { setUserProfiles } from 'src/app/core/session';
import { ScreenshotService } from 'src/app/services/shared/screenshot.service';
import { LoaderService } from 'src/app/services/interceptor/loader.service';
@Component({
  selector: 'app-register-business',
  templateUrl: './register-business.component.html',
  styleUrls: ['./register-business.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterBusinessComponent implements OnInit, OnDestroy {
  signup_type: any = null
  currentView: any = "view1"
  hidePwd: any = false;
  industryList: any = [];
  sub_industrys: any = [];
  mask = REGEX.mobile_mask;
  tin_mask = REGEX.tin_mask;
  queryParamSubscription: Subscription;
  partnerId: string;
  changePanel: number = 0;
  resendTime: any = '02:59';
  time: any = null;
  email_otp: string;
  selection_type: number = 0;
  showOTP: boolean;
  mobile_otp: string;
  urlwindow: any;
  URL_regex: any = /^(https?:\/\/)?([\w\-]+\.)+(com|org|net|edu|gov|co|in|uk|io|me|info|biz|us|app)(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
  businessId: string;
  referral_show: boolean = false
  passwordPolicyContainer: boolean = false;
  realValue: string = '';
  // terms & conditions modal
  termsModalOpen: boolean = false;
  termsAgreeChecked: boolean = false;
  showTermsScrollHint: boolean = true;
  // agree checkbox only shows once the terms were scrolled to the very end, and stays after that
  termsReadToEnd: boolean = false;
  terms_html: any = 'Loading...';
  // the modal as it looked when Accept was clicked, uploaded once signup succeeds
  termsScreenshot: Blob | null = null;
  private capturingTerms: boolean = false;
  @ViewChild('passwordContainer', {static: false}) passwordContainer : ElementRef;
  @ViewChild('termsContent', {static: false}) termsContent : ElementRef;
  constructor(
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
    public mainService: MainService,
    private fb: UntypedFormBuilder,
    private router: Router,
    public _persona: PersonaService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private screenshotService: ScreenshotService,
    private loaderService: LoaderService
  ) {
    this.storeCaptcha();
  }
  signUpForm: any;
  current_language: any;
  font_size_change_lang = {
    "en": [],
    "de": ['referral_code'],
    "fr": ['tin'],
    "es": [],
    "it": [],
    "ja": ['referral_code'],
    "pl": [],
    "zh-TW": []
  }
  step_value = ""
  ngOnInit() {
    if (environment.production) {
      this.canonicalService.setCanonicalURL('https://business.denefits.com/register/');
      this.metaTagService.addTags([
        { name: 'title', content: "Let's Get Your Business Registered - Denefits" },
        { name: 'description', content: 'Register your business by filling in the following information. Denefits - Complete Payment Options offers financing to all with No Credit Checks.' },
        { name: 'robots', content: 'index, follow' }
      ]);
    }
    // params businessid and partner id come
    this.queryParamSubscription = this.route.queryParams.subscribe(params => {
      if (params && params.partner) {
        this.partnerId = params.partner;
      } else if (params && params.business_id) {
        this.businessId = params.business_id;
      }
    });

    this.initForm();
    let token = localStorage.getItem('token');
    if (token !== null && token !== undefined) {
      this.router.navigate(['app/finance-customer'])
    }
    this.getIndustryList();
    this.current_language = this.mainService.gt_get_cookie('googtrans').split('/').pop() || "en";

    if (this.partnerId) {
      this.signUpForm.get("third_page").patchValue({ referral_code: this.partnerId });
      this.referral_show=true
    } else if (this.businessId) {
      this.signUpForm.get("third_page").patchValue({ referral_code: this.businessId });
      this.referral_show=true
    } else {
      this.signUpForm.get("third_page").patchValue({ referral_code: '' });
    }
    if (this.currentView == 'view1') localStorage.removeItem('signup_value')
    if(this.referral_show === true) this.currentView = 'view2'
  }

  initForm() {
    this.signUpForm = this.fb.group({
      first_page: this.fb.group({
        device_token: 'Website',
        device_type: 0,
        app_type: 2,
        app_version: environment.app_version,
        device_id: localStorage.getItem('user'),
        doctor_first_name: ['', [Validators.required, Validators.pattern(REGEX.Name_1), Validators.maxLength(30)]],
        doctor_last_name: ['', [Validators.required, Validators.pattern(REGEX.Name_1), Validators.maxLength(30)]],
        doctor_email: ['', [Validators.required, Validators.pattern(REGEX.Email)]],
        doctor_mobile: ['', [Validators.required]],
        doctor_password: ['', [Validators.required, this.passwordPolicyValidator()]],
      }),
      second_page: this.fb.group({
        otp: ['', [Validators.required]]
      }),
      third_page: this.fb.group({
        practice_name: ['', [Validators.required, Validators.maxLength(50)]],
        ind_id: ['', [Validators.required]],
        sub_ind_id: ['', [Validators.required]],
        sub_ind_name: ['', [Validators.pattern(/^[a-zA-Z0-9 ]*$/)]],
        ind_name: ['', [Validators.pattern(/^[a-zA-Z0-9 ]*$/)]],
        TnC: [false, [Validators.required]],
        referral_code: [{ value: this.partnerId || this.businessId || '', disabled: (this.partnerId || this.businessId) ? true : false }],
        captcha: ['', [Validators.required]],
        website: ['', [Validators.required, Validators.pattern(this.URL_regex), Validators.maxLength(2048)]]
      })
    })

    // this.signUpForm = this.fb.group({

    //   doctor_speciality: [''],
    //   website: ['', [Validators.pattern(this.URL_regex)]],
    //   tin: [null],
    //  
    //   referral_code: [{ value: this.partnerId || this.businessId || '', disabled: (this.partnerId || this.businessId) ? true: false}],
    //   message_id: [''],
    //   query: [''],
    //   reason: [''],
    //   otp: [''],
    //   captcha: ['', [Validators.required]]
    // })
  }

  storeCaptcha() {
    let data = {
      device_id: localStorage.getItem('user') || this.mainService.guid()
    }
    this.mainService.api(data, 'store_captcha', false).subscribe((res) => {
      if (res && res.is_error == 0) {
        this.urlwindow = res.data;
      }
      else {
        return;
      }
    })
  }

  getIndustryList() {
    this.mainService.getIndustryList().subscribe((industries) => {
      this.industryList = industries;
    });
  }

  getSubIndustrylist(value?) {
    let data = {
      ind_id: parseInt(this.signUpForm.get('third_page.ind_id').value),
      is_deleted: 0,
      is_verified: 1,
      full_data: 0,
    }
    this.mainService.api(data, 'get_all_sub_industries', false).subscribe((data) => {
      if (data && data.is_error == 0) {
        if (data.paignated_result.length == 1 && data.paignated_result[0].doctor_speciality === '9999') {
          this.signUpForm.get("third_page.sub_ind_id").setValue(9999);
          this.signUpForm.get('third_page.sub_ind_name').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]*$/)]);
        }
        else {
          this.signUpForm.get("third_page.sub_ind_id").setValue('');
          this.signUpForm.get("third_page.sub_ind_id").markAsPristine();
        }
        this.sub_industrys = data.paignated_result;
        this.signUpForm.markAsPristine();
        this.signUpForm.updateValueAndValidity();
      }
      else {
        return []
      }
    })
  }

  valueChange(event) {
    try {
      if ((this.signUpForm.get("third_page.ind_id").value === 9999 || this.signUpForm.get("third_page.ind_id").value === '9999')) {
        if (this.signUpForm.get("third_page.ind_id").value === '9999') {
          this.signUpForm.get('third_page.ind_name').setValue('')
          this.signUpForm.get('third_page.ind_name').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]*$/)]);
          this.signUpForm.get('third_page.sub_ind_id').setValue('9999');
          this.signUpForm.get('third_page').updateValueAndValidity();
          this.signUpForm.get('third_page.ind_name').setErrors({ require: true })
        }
        if (this.signUpForm.get('third_page.sub_ind_id').value === '9999' || this.signUpForm.get('third_page.sub_ind_id').value === 9999) {
          this.signUpForm.get('third_page.sub_ind_name').setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]*$/)]);
          this.signUpForm.get('third_page').updateValueAndValidity();
        }
      } else {
        if (this.signUpForm.get("third_page.ind_id").value !== 9999) {
          this.signUpForm.get('third_page.ind_name').setValue(null)
          this.signUpForm.get('third_page.ind_name').clearValidators();
          this.signUpForm.get('third_page.ind_name').setErrors(null);
          this.signUpForm.get('third_page.sub_ind_name').clearValidators();
          this.signUpForm.get('third_page.sub_ind_name').setErrors(null);
          this.signUpForm.get('third_page.sub_ind_id').markAsPristine();
        }
        if (this.signUpForm.get('third_page.sub_ind_id').value == 9999) {
          this.signUpForm.get('third_page.sub_ind_name').setValue('');
          this.signUpForm.get('third_page.sub_ind_name').setValidators(Validators.required);
        } else {
          this.signUpForm.get('third_page.sub_ind_name').clearValidators();
          this.signUpForm.get('third_page.sub_ind_name').setErrors(null);
          this.signUpForm.get('third_page.sub_ind_id').markAsUntouched();
          this.signUpForm.get('third_page.sub_ind_id').markAsPristine();
        }
      }
      this.signUpForm.get('third_page').updateValueAndValidity();
    } catch (error) {
      console.log(error);
    }

  }

  checkDoctorPartnerStatus() {
    if (this.signUpForm.controls.otp.errors && this.signUpForm.controls.otp.errors.required) {
      this.signUpForm.controls.otp.clearValidators();
      this.signUpForm.controls.otp.updateValueAndValidity();
    }
    if (this.signUpForm.invalid) {
      this.signUpForm.markAsDirty();
      this.signUpForm.markAllAsTouched()
      return;
    }

    if (this.signUpForm.value && (this.signUpForm.value.message_id == 1 || this.signUpForm.value.message_id == 4) && !this.signUpForm.value.reason) {
      this.mainService.customPopups('Please tell how you heard about us.', 1);
      return false;
    }

    if (this.signUpForm.controls.TnC.value == false) {
      this.signUpForm.markAsDirty();
      this.signUpForm.markAllAsTouched()
      return;
    }

    if (this.signUpForm.controls['referral_code'].value) {
      let data = {
        refer_code: this.signUpForm.controls.referral_code.value
      }
      this.mainService.api(data, 'check_partner_doctor_id', false).subscribe((data) => {
        if (data.is_error == 0) {
          this.checkEmail()
        } else {
          this.signUpForm.markAsDirty()
          this.signUpForm.markAsTouched()
          this.mainService.customPopups(data.err, 1);
          return;
        }
      })
    } else {
      this.checkEmail();
    }
  }

  checkEmail(form_value?) {
    if (this.signUpForm.get(form_value).invalid) {
      this.signUpForm.get(form_value).markAsDirty();
      this.signUpForm.get(form_value).markAllAsTouched()
      return;
    }
    let data = {
      doctor_email: this.signUpForm.get(form_value).get('doctor_email').value
    }
    this.mainService.api(data, 'check_doctor_email', false).subscribe((data) => {
      if (data.is_error == 0) {
        this.checkDoctorMobile(form_value)
      } else {
        this.signUpForm.get(form_value).markAsDirty()
        this.signUpForm.get(form_value).markAsTouched()
        this.signUpForm.get(form_value).get('doctor_email').setErrors({ email_exists: "Email address already exist's" });
      }
    })
  }

  checkDoctorMobile(form_value?) {
    if (this.signUpForm.get(form_value).invalid) {
      this.signUpForm.get(form_value).markAsDirty();
      this.signUpForm.get(form_value).markAllAsTouched()
      return;
    }
    let data = {
      doctor_mobile: '+1-' + this.signUpForm.get(form_value).get('doctor_mobile').value.toString(),
      doctor_id: 0
    }
    this.mainService.api(data, 'check_doctor_mobile', false).subscribe((data) => {
      if (data.is_error == 0) {
        if (this.signUpForm.get('third_page').get('referral_code').value == '' || this.signUpForm.get('third_page').get('referral_code').value == null) {
          this.signUpForm.get('third_page').get('referral_code').clearAsyncValidators();
          this.signUpForm.get('third_page').get('referral_code').clearValidators();
          this.signUpForm.get('third_page').get('referral_code').setErrors(null);
          this.signUpForm.get('third_page').get('referral_code').setValue('');
          this.signUpForm.updateValueAndValidity();
          this.ForwardSingupValue(this.currentView, 'view3')
        }else{
          this.ForwardSingupValue(this.currentView, 'view3')
        }
        // this.verify_captcha();
      } else {
        this.signUpForm.get(form_value).get("doctor_mobile").setErrors({ phone_error: "Phone number already registered" });
      }
    })
  }

  verify_captcha() {
    if (this.signUpForm.get('third_page').invalid) {
      this.signUpForm.get('third_page').markAsDirty();
      this.signUpForm.get('third_page').markAllAsTouched()
      return;
    }
    let data = {
      device_id: localStorage.getItem('user'),
      captcha_value: this.signUpForm.get("third_page.captcha").value,
      is_skip_popup: 1

    }
    this.mainService.api(data, 'verfiy_captcha', false).subscribe((res) => {
      if (res && res.is_error == 0) {
        if (this.signUpForm.get("first_page.doctor_mobile").value) {
          let doctor_mob = this.signUpForm.get("first_page.doctor_mobile").value;
          let a = doctor_mob.slice(0, 3);
          let b = doctor_mob.slice(3, 6);
          let c = doctor_mob.slice(6, 10);
          this.mobile_otp = `${a}-${b}-${c}`;
        }
        this.changePanel = 1;
        this.sinupUser()
      }
      else {
        this.signUpForm.get('third_page.captcha').setErrors({ invalid: true });
        this.signUpForm.get('third_page.captcha').markAllAsTouched()
        this.signUpForm.get('third_page.captcha').markAsDirty()
        // this.mainService.customPopups(res.err, 1);
        this.storeCaptcha();
        return;
      }
    })
  }

  checkSelection(val) {
    this.selection_type = val;
    this.showOTP = false;

    const doctorMobileControl = this.signUpForm.get('first_page.doctor_mobile');
    const doctorMobile = doctorMobileControl ? doctorMobileControl.value : '';

    if (doctorMobile) {
      const trimmedMobile = doctorMobile.trim();
      if (this.selection_type === 2) {
        this.email_otp = `******${trimmedMobile.slice(-4)}`;
      } else {
        this.email_otp = trimmedMobile;
      }
    } else {
      this.email_otp = '';
    }
  }


  sinupUser() {

    let data: any = {
    };
    const data1 = JSON.parse(JSON.stringify(this.signUpForm.get('first_page').value))
    const data2 = JSON.parse(JSON.stringify(this.signUpForm.get('second_page').value))
    const data3 = JSON.parse(JSON.stringify(this.signUpForm.get('third_page').value))
    data = { ...data1, ...data2, ...data3 }
    // data['sub_ind_id'] = this.signUpForm.controls['sub_ind_id'].value;
    // data['doctor_mobile'] = `+1-${this.signUpForm.controls.doctor_mobile.value}`;
    // if (!data['referral_code']) {
    //   data['referral_code'] = '';
    // }
    data.doctor_mobile = '+1-' + this.signUpForm.get('first_page').get('doctor_mobile').value.toString()
    data.doctor_password = this.mainService.encryptInMD5(this.signUpForm.get('first_page').get('doctor_password').value);
    // referaal code
    if (this.partnerId) {
      data['referral_code'] = this.partnerId;
      data['isReferredByPartner'] = true;
    } if (this.businessId) {
      data['referral_code'] = this.businessId;
      data['isReferredByBusiness'] = true;
    }
    // langugae
    const currentLanguage = this.mainService.gt_get_cookie('googtrans').split('/').pop();
    data['language_preferred'] = currentLanguage;

    if (data && !data.TnC) {
      this.signUpForm.get('third_page.TnC').markAsDirty()
      this.signUpForm.get('third_page.TnC').markAsTouched()
      return
    }
    if (data) {
      data.signup_type = this.signup_type || null;
    }
    this.mainService.api(data, 'register_business_v2', false)
      .subscribe((response: any) => {
        if (response.is_error == 1) {
          if (response.original_text === 'Phone number already registered') {
            this.mainService.customPopups("Phone number already registered", 1);
            return;
          }
          if (response.original_text == "Please enter a valid Partner ID") {
            this.mainService.customPopups(response.err, 1);
            return;
          }
          // this.signUpForm.setErrors({ other_err: response.err })
        }
        if (response && response.is_error == 0) {
          response.profile[0].business_verification_state = 'registered';
          response.profile[0].doctor_profile = 'registered';
          setUserProfiles(response.profile)
          this.mainService.available_menu.next(response.menu);
          this.mainService.flagPopUps(response.flag, '');
          this.auth.setLoginData(response);
          this.uploadTermsScreenshot(response.profile[0].doctor_id);
          this.auth.accessTokenLogin();
          setTimeout(() => {
            this.mainService.init();
          }, 500);
        }
      });
  }

  changeSelection() {
    if (this.signUpForm.value.message_id !== 1 && this.signUpForm.value.message_id !== 4) {
      this.signUpForm.get('reason').reset();
      this.signUpForm.controls['reason'].clearValidators();
      this.signUpForm.controls['reason'].updateValueAndValidity();
    }
    if (this.signUpForm.value.message_id == 1 || this.signUpForm.value.message_id == 4) {
      this.signUpForm.controls['reason'].setValue('');
      this.signUpForm.controls['reason'].setValidators(Validators.required);
      this.signUpForm.controls['reason'].updateValueAndValidity();
    }
  }

  verifyOtp() {
    console.log(this.signUpForm.get('second_page'), ">>>");

    if (this.signUpForm.get('second_page.otp').value == '') {
      this.signUpForm.get('second_page.otp').setErrors({ emial_otp_none: 'Please enter verification code to verify' });
      return
    }

    const data = {
      otp: this.signUpForm.get('second_page.otp').value,
      doctor_email: this.signUpForm.get('first_page.doctor_email').value,
      doctor_mobile: this.signUpForm.get('first_page.doctor_mobile').value,
      device_type: environment.device_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: localStorage.getItem('user'),
      is_skip_popup: 1
    };
    this.mainService.api(data, 'verify_register_otp', true).subscribe(async (response) => {
      if (response.is_error == 1) {
        this.signUpForm.get('second_page.otp').setErrors({ emial_otp_none: response.err });
        return
      }
      if (response.is_error === 0) {
        this.currentView = 'view5'
        this.ForwardSingupValue('view4', 'view5')
        // this.sinupUser();
      } else {
        if (response.override_text || response.err) {
          // this.mainService.customPopups(response.override_text || response.err, 1);
        } else {
          // this.mainService.flagPopUps(response.flag, response.is_error);
        }
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  setResendTime() {
    this.time = new Date(new Date().setMinutes(new Date().getMinutes() + 3));
    var x = setInterval(() => {
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = this.time - now;

      // Time calculations for days, hours, minutes and seconds
      var minutes = '0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();

      var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();
      seconds = seconds && seconds.toString().length == 1 ? '0' + seconds.toString() : seconds.toString();

      // Output the result in an element with id="demo"
      this.resendTime = minutes.toString() + ":" + seconds;
      // If the count down is over, write some text 
      if (distance < 0) {
        this.time = 0;
        this.resendTime = "00:00";
        clearInterval(x);
      }
    }, 1000);
  }

  GenerateOtp(current_vlaue?) {
    if (this.selection_type == 1) {
      if (this.signUpForm.get('first_page.doctor_email').value.trim() == '') {
        this.signUpForm.get('first_page.doctor_email').setErrors({ emial_phone_null: "Please enter a valid email." });
        return
      }
      if (!new RegExp(REGEX.Email).test(this.signUpForm.get('first_page.doctor_email').value.trim()) && isNaN(this.signUpForm.get('first_page.doctor_email').value.trim())) {
        this.signUpForm.get('first_page.doctor_email').setErrors({ emial_phone_null: 'Please enter a valid email/phone.' });
        return
      }
    } else {
      if (!new RegExp(REGEX.mobile).test(this.signUpForm.get('first_page.doctor_email').value.trim()) && !isNaN(this.signUpForm.get('first_page.doctor_email').value.trim())) {
        this.signUpForm.get('first_page.doctor_email').setErrors({ emial_phone_null: 'Phone number is not valid.' });
        return
      }
    }

    let data = {
      doctor_first_name: this.signUpForm.get('first_page.doctor_first_name').value.trim(),
      doctor_last_name: this.signUpForm.get('first_page.doctor_last_name').value.trim(),
    }
    if (this.selection_type == 1) {
      data['email'] = isNaN(this.signUpForm.get('first_page.doctor_email').value.trim()) ? this.signUpForm.get('first_page.doctor_email').value.trim() : Number(this.signUpForm.get('first_page.doctor_email').value.trim())
    } else {
      data['mobile'] = this.signUpForm.get('first_page.doctor_mobile').value
    }
    this.mainService.api(data, 'register_otp', true).subscribe((data) => {
      if (data.is_error == 0) {
        this.signUpForm.get('second_page.otp').reset();
        this.showOTP = true;
        this.signUpForm.get('second_page.otp').setValue('')
        this.setResendTime()
        if (current_vlaue == 'view4') {
          this.currentView = current_vlaue
        }
      }
    })
  }

  goBack() {
    this.changePanel = 0;
    this.selection_type = 0;
    this.showOTP = false;
  }

  ForwardSingupValue(prev: any, next: any) {
    localStorage.setItem("signup_value", JSON.stringify({ prev: prev, next: next }));
    this.currentView = next
  }
  BackSingupValue(prev, next) {
    localStorage.setItem("signup_value", JSON.stringify({ prev: prev, next: next }));
    this.currentView = prev
  }

  // phone number translate
  transform(value: string | number): string {
    if (!value) {
      return '';
    }
    let phoneStr = value.toString();
    if (phoneStr.length !== 10) {
      return phoneStr;
    }
    const part1 = phoneStr.slice(0, 3);
    const part2 = phoneStr.slice(3, 6);
    const part3 = phoneStr.slice(6, 10);
    // Format the phone number
    return `(${part1}) ${part2} ${part3}`;
  }

  passwordPolicyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const errors: ValidationErrors = {};
    if (value.length < 8) {
      errors['minLength'] = true;
    }
    if (!/[a-z]/.test(value)) {
      errors['lowercase'] = true;
    }
    if (!/[A-Z]/.test(value)) {
      errors['uppercase'] = true;
    }
    if (!/\d/.test(value)) {
      errors['number'] = true;
    }
    if (!/[!@#$%^&*]/.test(value)) {
      errors['specialChar'] = true;
    }
    if(value && value[value.length-1] == ' '){
      errors['trailingspace'] =true;
    }

    return Object.keys(errors).length ? errors : null;
    };
  }

  get signerName(): string {
    const first = this.signUpForm && this.signUpForm.get('first_page.doctor_first_name').value || '';
    const last = this.signUpForm && this.signUpForm.get('first_page.doctor_last_name').value || '';
    return `${first} ${last}`.trim();
  }

  get tncControl(): AbstractControl {
    return this.signUpForm.get('third_page.TnC');
  }

  // medical industries get a different terms document, same mapping the /terms routes use
  get termsTemplateName(): string {
    const ind_id = this.signUpForm.get('third_page.ind_id').value;
    return (ind_id == 1 || ind_id == 6 || ind_id == 1266) ? 'TERMS_AND_CONDITION' : 'BUSINESS_NON_MEDICAL_TERMS_AND_CONDITION';
  }

  // industry drives which terms apply, so anything already accepted no longer counts
  onIndustryChanged() {
    this.termsScreenshot = null;
    this.termsAgreeChecked = false;
    this.signUpForm.get('third_page.TnC').setValue(false);
    this.signUpForm.get('third_page.TnC').markAsUntouched();
  }

  openTermsModal() {
    this.termsModalOpen = true;
    this.showTermsScrollHint = true;
    this.termsReadToEnd = false;
    this.termsAgreeChecked = this.signUpForm.get('third_page.TnC').value == true;
    // industry can change between opens, so always pull the content that matches it now
    this.terms_html = 'Loading...';
    this.getTermsContent();
  }

  closeTermsModal() {
    this.termsModalOpen = false;
  }

  getTermsContent() {
    const data = {
      template_name: this.termsTemplateName,
      type: 1
    }
    this.mainService.api(data, `cms_details_for_panel?lang=${this.current_language || 'en'}`, false, 'object')
      .subscribe((response) => {
        if (response && response.is_error == 0) {
          this.terms_html = response.data.content;
        } else {
          this.terms_html = '<h3 class="text-center">Unable to fetch content from server.</h3>';
        }
        setTimeout(() => this.resetTermsScroll(), 300);
      });
  }

  resetTermsScroll() {
    const el = this.termsContent && this.termsContent.nativeElement;
    if (!el) return;
    el.scrollTop = 0;
    // content may be short enough that it never scrolls, hide the hint then
    this.showTermsScrollHint = el.scrollHeight - el.clientHeight >= 20;
    // and nothing to scroll means it is already read to the end
    this.termsReadToEnd = this.isTermsAtEnd(el);
  }

  onTermsAgreeChange(event: any) {
    this.termsAgreeChecked = event.target.checked;
  }

  onTermsScroll(event: any) {
    const el = event.target;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 20;
    this.showTermsScrollHint = !atBottom;
    // never flipped back, scrolling up again after reaching the end keeps the checkbox
    if (this.isTermsAtEnd(el)) this.termsReadToEnd = true;
  }

  // a couple of px of slack - on zoomed screens scrollTop can stop a fraction short of the end
  private isTermsAtEnd(el: HTMLElement): boolean {
    return el.scrollHeight - el.scrollTop - el.clientHeight <= 2;
  }

  scrollTermsDown() {
    const el = this.termsContent && this.termsContent.nativeElement;
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  }

  async acceptTerms() {
    if (!this.termsAgreeChecked || !this.termsReadToEnd || this.capturingTerms) return;
    this.capturingTerms = true;
    this.loaderService.show();
    let shot: Blob | null = null;
    try {
      await new Promise<void>(resolve =>
        requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(resolve, 0)))
      );
      shot = await this.captureTermsScreen();
    } finally {
      this.loaderService.hide();
      this.capturingTerms = false;
    }

    this.signUpForm.get('third_page.TnC').setValue(true);
    this.signUpForm.get('third_page.TnC').markAsTouched();
    this.signUpForm.get('third_page.TnC').markAsDirty();
    this.termsModalOpen = false;
    this.termsScreenshot = shot;

    // if(shot) {
    //   console.log('shot::::: ',shot);
    //   window.open(URL.createObjectURL(shot));
    // }
  }

  private async captureTermsScreen(): Promise<Blob | null> {
    try {
      return await this.screenshotService.capture({ element: document.body, visibleOnly: true });
    } catch (error) {
      console.warn('Terms screenshot capture failed:', error);
      return null;
    }
  }

  private uploadTermsScreenshot(doctor_id: any) {
    if (!this.termsScreenshot || !doctor_id) return;
    this.screenshotService.upload(this.termsScreenshot, {
      fileName: `tnc_accept_${doctor_id}_${Date.now()}.jpg`,
      extraParams: { doctor_id: doctor_id, is_terms: 1 }
    }).subscribe((response) => {
      if (!response || response.is_error == 1) {
        console.warn('Terms screenshot upload failed:', response);
      }
    });
    this.termsScreenshot = null;
  }

  declineTerms() {
    this.termsScreenshot = null;
    this.termsAgreeChecked = false;
    this.signUpForm.get('third_page.TnC').setValue(false);
    this.signUpForm.get('third_page.TnC').markAsTouched();
    this.signUpForm.get('third_page.TnC').markAsDirty();
    this.termsModalOpen = false;
  }

  showPasswordPolicyContainer(){
    this.passwordPolicyContainer = true;
  }

  hidePasswordPolicyContainer(){
    this.passwordPolicyContainer = false;
    if(this.signUpForm.get('first_page.doctor_password').touched && this.signUpForm.get('first_page.doctor_password').errors && this.signUpForm.get('first_page.doctor_password').errors.trailingspace){
      this.mainService.customPopups("Please don’t end your password with blank space.",2);
    } 
  }

  ngOnDestroy(): void {
    this.queryParamSubscription && this.queryParamSubscription.unsubscribe();
  }

  get displayedValue(): string {
    return this.hidePwd ? this.realValue : '•'.repeat(this.realValue.length);
  }

  handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    if (this.hidePwd) {
      this.realValue = newValue;
    } else {
      if (newValue.length < this.realValue.length) {
        this.realValue = this.realValue.slice(0, newValue.length);
      } else {
        const addedText = newValue.slice(this.realValue.length);
        this.realValue += addedText;
      }
    }
    this.signUpForm.get('first_page.doctor_password').setValue(this.realValue, { emitEvent: true });
  }

}